export const minLicenses = 0;
export const maxLicenses = 150;
export const defaultStandardLicenses = 5;
export const defaultPremiumLicenses = 5;
export const defaultOption = 'option1';

// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30PA = '30AGF';
